import { render, staticRenderFns } from "./book-author.vue?vue&type=template&id=50281c8b&scoped=true"
import script from "./book-author.vue?vue&type=script&lang=js"
export * from "./book-author.vue?vue&type=script&lang=js"
import style0 from "./book-author.vue?vue&type=style&index=0&id=50281c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50281c8b",
  null
  
)

export default component.exports